import { getCompany, getConnector, getTaskAndTaskWorkflow, getUserAndEventTime } from './lib/index.js';
import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
export const createIdentitySyncedSamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.IDENTITY_SYNCED,
        ...getUserAndEventTime(),
        ...getTaskAndTaskWorkflow(),
        data: {
            identity: {
                firstName: 'Jane',
                lastName: 'Appleseed',
                dateOfBirth: '1984-04-12T12:00:00.000Z',
                email: 'janeappleseed@example.com',
                phone: '5558881111',
                ssn: '111223333',
                address: '123 Example St.',
                city: 'Salt Lake City',
                state: 'UT',
                postalCode: '84111'
            },
            ...getCompany(),
            ...getConnector(),
            linkedAccount: '5f7212103a40e91f95ba376d'
        }
    };
};
//# sourceMappingURL=identity-synced.js.map